import { render, staticRenderFns } from "./wechatStatistics.vue?vue&type=template&id=8271853c&scoped=true"
import script from "./wechatStatistics.vue?vue&type=script&lang=js"
export * from "./wechatStatistics.vue?vue&type=script&lang=js"
import style0 from "./wechatStatistics.vue?vue&type=style&index=0&id=8271853c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8271853c",
  null
  
)

export default component.exports